import React, {useEffect, useState} from "react";
import './Premium.scss';

import Header from "../../components/Header";
import Button from "react-bootstrap/Button";
import Footer from "../../components/Footer";
import Alert from "react-bootstrap/Alert";
import {Modal, Table} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faCreditCard} from "@fortawesome/free-solid-svg-icons";
import LoginComponent from "../../components/Profile/LoginComponent";
import RegisterComponent from "../../components/Profile/RegisterComponent";
import {faPaypal} from "@fortawesome/free-brands-svg-icons";
import {toast} from "react-toastify";

function PremiumPurchase() {
    useEffect(() => {
        document.title = "Geoticket - Acquisto Premium";
    }, []);

    const [priceMontly, setPriceMontly] = useState(null);
    const [priceYearly, setPriceYearly] = useState(null);
    const [subscriptionSelected, setSubscriptionSelected] = useState(null);
    const [isLoadingPayment, setLoadingPayment] = React.useState(false);

    const [user, setUser] = useState(null);

    const [showModalLogin, setShowModalLogin] = React.useState(false);
    const [showModalRegister, setShowModalRegister] = React.useState(false);
    useEffect(() => {
        global.permission().then((user) => {
            setUser(user);
        }).catch(error => {
        });
    }, []);

    function callbackLogin(user) {
        setUser(user);

    }

    useEffect(() => {
        fetch(global.route.subscriptionPrice, {
            method: "post",
            credentials: 'include',
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(response => {
                        setPriceMontly(response.price_monthly);
                        setPriceYearly(response.price_yearly);
                    });
                }
            });
    }, []);

    function getSubscription() {
        if (priceMontly === null || priceYearly === null)
            return;

        return <div className={"row"}>
            <div className={"col-md-6"}>
                <div className={"card-price " + (subscriptionSelected === "MONTHLY" ? "card-price-selected" : "")}
                     onClick={() => setSubscriptionSelected("MONTHLY")}>
                    <h4>1 Mese</h4>
                    <p>€ {priceMontly.toFixed(2)}/Mese</p>
                    <b className={"orange"}>Totale: {priceMontly.toFixed(2)}</b>
                    <div className={"d-flex justify-content-center align-items-center"}>
                        <Button className={"btn-orange"}
                                disabled={subscriptionSelected === "MONTHLY"}>Seleziona</Button>
                    </div>
                </div>
            </div>
            <div className={"col-md-6"}>
                <div className={"card-price " + (subscriptionSelected === "YEARLY" ? "card-price-selected" : "")}
                     onClick={() => setSubscriptionSelected("YEARLY")}>
                    <h4>1 Anno</h4>
                    <p>€ {(priceYearly / 12).toFixed(2)}/Mese</p>
                    <b className={"orange"}>Totale: {priceYearly.toFixed(2)}</b>
                    <div className={"d-flex justify-content-center align-items-center"}>
                        <Button className={"btn-orange"} disabled={subscriptionSelected === "YEARLY"}>Seleziona</Button>
                    </div>
                </div>
            </div>
        </div>
    }

    function getBuy() {
        if (user === null)
            return <div className={"text-center mb-2 mt-2"}>Per completare il pagamento devi effettuare<br/> il <Button
                className={"btn-orange"}
                onClick={() => setShowModalLogin(true)}>login</Button> oppure <Button
                className={"btn-orange"} onClick={() => setShowModalRegister(true)}>registrati</Button>
            </div>
        if (user.premium !== null)
            return (<Alert variant={"warning"}>Hai già l'abbonamento attivo</Alert>)

        return <div className={"d-flex justify-content-center mt-4"}>
            <Button variant="success" className={"m-2"}
                    onClick={() => checkout("PAYMENT_PAYPAL")}
                    disabled={isLoadingPayment}>
                <FontAwesomeIcon icon={faPaypal} style={{marginRight: 4}} size={"sm"}/>Paga con PayPal
            </Button>
            <Button variant="success" className={"m-2"}
                    onClick={() => checkout("PAYMENT_STRIPE")} disabled={isLoadingPayment}>
                <FontAwesomeIcon icon={faCreditCard} style={{marginRight: 4}} size={"sm"}/>Paga con Carta
            </Button>
        </div>
    }

    let checkout = (type_payment) => {
        if (subscriptionSelected === null) {
            toast.warning("Devi selezionare l'abbonamento da acquistare")
            return;
        }
        setLoadingPayment(true);

        fetch(global.route.subscriptionBuy, {
            method: "post",
            credentials: 'include',
            body: global.getFormData({
                type_subscription: subscriptionSelected,
                type_payment: type_payment,
                source: "webapp"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    global.catchError(response);
                    setLoadingPayment(false);
                } else {
                    response.json().then(response => {
                        if (response.url !== undefined)
                            window.location.href = response.url;
                        setLoadingPayment(false);
                    });
                }
            });
    }

    return (
        <div className={"premium-purchase"}>
            <Header/>
            <div style={{paddingTop: 86}}>
                <div className="container">
                    <div className="card mb-4">
                        <div className="card-body">
                            <h1 className={"orange"}>Geoticket+</h1>
                            <h4>Scopri i vantaggi di Geoticket+</h4>
                            <br/>
                            <Table striped bordered hover>
                                <thead>
                                <tr>
                                    <th>Vantaggi</th>
                                    <th>Senza Geoticket+</th>
                                    <th className={"orange"}>Con Geoticket+</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>App e sito web senza pubblicità</td>
                                    <td></td>
                                    <td><FontAwesomeIcon icon={faCheck} color={"#ED8829"}/></td>
                                </tr>
                                <tr>
                                    <td>Notifiche meteo nell'area della tua attività</td>
                                    <td></td>
                                    <td><FontAwesomeIcon icon={faCheck} color={"#ED8829"}/></td>
                                </tr>
                                <tr>
                                    <td>Sconti esclusivi e pacchetti aggiuntivi</td>
                                    <td></td>
                                    <td><FontAwesomeIcon icon={faCheck} color={"#ED8829"}/></td>
                                </tr>
                                <tr>
                                    <td>Segna e mappa i funghi che hai raccolto</td>
                                    <td></td>
                                    <td><FontAwesomeIcon icon={faCheck} color={"#ED8829"}/></td>
                                </tr>
                                <tr>
                                    <td>Guide e consigli per pesca e raccolta funghi</td>
                                    <td></td>
                                    <td><FontAwesomeIcon icon={faCheck} color={"#ED8829"}/></td>
                                </tr>
                                <tr>
                                    <td>Mappa intelligente della crescita funghi</td>
                                    <td></td>
                                    <td><FontAwesomeIcon icon={faCheck} color={"#ED8829"}/></td>
                                </tr>
                                </tbody>
                            </Table>

                        </div>
                        <div className={"trial"}>
                            Iscrivendoti a Geoticket+, ottieni una prova gratuita di 7 giorni!
                        </div>
                        <div className="card-body">
                            {getSubscription()}
                            {getBuy()}
                        </div>
                    </div>
                </div>
                <Modal show={showModalLogin} centered onHide={() => {
                    setShowModalLogin(false)
                }}>
                    <Modal.Header closeButton/>
                    <Modal.Body>
                        <LoginComponent onLogin={callbackLogin}/>
                    </Modal.Body>
                </Modal>
                <Modal show={showModalRegister} centered onHide={() => {
                    setShowModalRegister(false)
                }}>
                    <Modal.Header closeButton/>
                    <Modal.Body>
                        <RegisterComponent onLogin={callbackLogin}/>
                    </Modal.Body>
                </Modal>
            </div>
            <Footer/>
        </div>
    );
}

export default PremiumPurchase;